export default "__VITE_ASSET__BE19e1WR__"